var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose32 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3137C0 9.19198 0.842852 7.15715 2.34314 5.65686L5.65685 2.34315C7.15715 0.842855 9.19198 0 11.3137 0H28C30.2091 0 32 1.79086 32 4V20.6863C32 22.808 31.1571 24.8429 29.6569 26.3431L26.3431 29.6569C24.8429 31.1571 22.808 32 20.6863 32H4C1.79086 32 0 30.2091 0 28V11.3137Z",
    fill: "#00BFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.275 11.6083C22.7958 11.0875 22.7958 10.2417 22.275 9.72083C21.7542 9.19999 20.9083 9.19999 20.3875 9.72083L16 14.1125L11.6083 9.72499C11.0875 9.20416 10.2417 9.20416 9.72083 9.72499C9.19999 10.2458 9.19999 11.0917 9.72083 11.6125L14.1125 16L9.72499 20.3917C9.20416 20.9125 9.20416 21.7583 9.72499 22.2792C10.2458 22.8 11.0917 22.8 11.6125 22.2792L16 17.8875L20.3917 22.275C20.9125 22.7958 21.7583 22.7958 22.2792 22.275C22.8 21.7542 22.8 20.9083 22.2792 20.3875L17.8875 16L22.275 11.6083Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClose32);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_close_32.49f08be6dbfe8ed54dc3185aa929edf6.svg";